import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, effect, model, OnChanges, OnInit, SimpleChanges, untracked } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { xDecimalPlacesAsFractionDigits } from '@phoenix/common';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { I18nService } from '../../../@core/services/i18n/i18n.service';
import { PhxInputNumberComponent } from '../../../shared/components/phx-input-number/phx-input-number.component';
import { LocaleDatePipe } from '../../../shared/pipes/locale-date.pipe';

@Component({
  selector: '',
  templateUrl: './formly-price-input.component.html',
  styleUrl: './formly-price-input.component.scss',
  providers: [
    LocaleDatePipe,
  ],
  imports: [
    CommonModule,
    InputTextModule,
    InputNumberModule,
    ReactiveFormsModule,
    FormlyModule,
    PhxInputNumberComponent
  ]
})
/**
 * use this component directly, only for ngx-formly - only for prices and models with decimalPlaces as 1, 0,1, 0,01 ...
 */
export class FormlyPriceInputComponent extends FieldType implements OnInit, AfterViewInit, OnChanges {

  minFractionDigits = model<number>(2);

  /**
 * @important if not set, it will be set to minFractionDigits, 
 * if lower than minFractionDigits, it will be set to minFractionDigits - otherwise minFractionDigits would not work
 */
  maxFractionDigits = model<number>(2);

  constructor(
    private i18n: I18nService
  ) {
    super();
    //important - since otherwise minFractionDigits doesnt work
    effect(() => {
      let minFractionDigits = this.minFractionDigits();
      let maxFractionDigits = this.maxFractionDigits();
      untracked(() => {
        if (maxFractionDigits < minFractionDigits) {
          this.maxFractionDigits.set(minFractionDigits);
        }
      })
    });
  }

  ngOnInit() {
    let decimalPlaces = this.model?.decimalPlaces;
    if (!decimalPlaces && this.formState?.detailComponent?.decimalPlaces)
      decimalPlaces = this.formState?.detailComponent?.decimalPlaces();
    if (!decimalPlaces) {
      decimalPlaces = "0.01"; // fallback to not let it fail
      console.warn(this.i18n.translate(_("common.decimal-places-default")))
    }
    const decimalPlacesAsMinFractionDigits = this.props?.minFractionDigits ?? xDecimalPlacesAsFractionDigits(decimalPlaces);
    if (decimalPlacesAsMinFractionDigits)
      this.minFractionDigits.set(decimalPlacesAsMinFractionDigits);
    // this is so that the decimalPlaces will also not be more then the specified ones
    if (!this.props?.maxFractionDigits && !this.maxFractionDigits())
      this.maxFractionDigits.set(decimalPlacesAsMinFractionDigits);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.props?.currentValue?.disabled !== changes.props?.previousValue?.disabled) {
      this.configureFormControl();
    }
  }

  ngAfterViewInit() {
    this.configureFormControl();
  }

  // DEV-755 It looks like you're using the disabled attribute with a reactive form directive
  private configureFormControl() {
    if (this.props?.disabled) {
      this.formControl.disable({ emitEvent: false }); // Disable the control
    } else {
      this.formControl.enable({ emitEvent: false }); // Enable the control
    }
  }
}
